import { HTTP_METHODS } from '@studio/constants/axios';
import { subtitlesApiUrl } from '@studio/constants/env-variables';
import type { Subtitles } from '@studio/types';

export const id = {
  [HTTP_METHODS.GET]: {
    url: `${subtitlesApiUrl}/transcript/@id`,
    method: HTTP_METHODS.GET,
    params: {} as { id: string },
    query: {} as {
      end?: string;
      start?: string;
    },
    response: [] as Subtitles.Get.Transcription[],
  },
};
